import React, { useCallback } from 'react';
import { Props } from './Nav.types';
import styles from './Nav.module.scss';
import { Icon } from 'modules/af_cm_ui_kit';
import { Icon as UIIcon } from 'lmc-ui-library';
import { NavLink } from 'react-router-dom';
import useNavItems from 'modules/cm/pages/CaseDetailsPage/partials/Nav/useNavItems';
import cx from 'classnames';

const Nav: React.FC<Props> = ({ onNavClick, applicants, resources, url, todoTasksCount }) => {
  const getTitleOption = useCallback(
    (titleValue: string): string => {
      const filter = resources.title.filter((title) => title.value === titleValue);
      return filter.length ? filter[0].option : titleValue;
    },
    [resources],
  );

  const [getNavItems] = useNavItems();

  return (
    <ul className={styles.nav}>
      <li>
        <NavLink
          to={`${url}/tasklist`}
          activeClassName={styles.active}
          className={cx(styles.item)}
          exact={false}
          onClick={onNavClick}>
          <div className={styles.label}>
            <Icon type={'declarations'} />
            <span>
              Tasks list
              {todoTasksCount > 0 && <span className={styles.todoTasksCount}> ({todoTasksCount} new)</span>}
            </span>
          </div>
        </NavLink>
        <hr />
      </li>

      {getNavItems(applicants, getTitleOption).map((item, i) => (
        <li key={`nav-${i}`}>
          <NavLink
            to={`${url}${item.to}`}
            activeClassName={styles.active}
            className={cx(styles.item, {
              [styles.error]: item.hasError,
            })}
            exact={item.exact}
            onClick={onNavClick}>
            <div className={styles.label}>
              {item.icon && <Icon type={item.icon} />}
              <span>{item.label}</span>
            </div>
            <div style={{ display: 'flex' }}>
              {item.items.length > 0 && (
                <div className={styles.toggle}>
                  <Icon type="arrowSolidDown" />
                </div>
              )}
              {item.hasError && <UIIcon type="error" color={`#FA5245`} />}
            </div>
          </NavLink>
          {item.items && (
            <ul className={styles.nav}>
              {item.items.map((item, ii) => (
                <li key={`nav-${i}-${ii}`}>
                  <NavLink
                    to={`${url}${item.to}`}
                    activeClassName={styles.active}
                    className={cx(styles.subItem, {
                      [styles.error]: item.hasError,
                    })}
                    onClick={onNavClick}>
                    <span>{item.label}</span>
                    {item.hasError && <UIIcon type="error" color={`#FA5245`} />}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </li>
      ))}
    </ul>
  );
};

export default Nav;
